import { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

export const useLegendMapArea = (warehouse_name, warehouse_type) => {
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `https://ctas.live/backend/api/${warehouse_type}/map/data?name=${warehouse_name}`,
          { headers: { "Content-Type": "application/json" } }
        );

        const Data = response.data?.data ?? [];

        let totalAreaSum = 0;
        let totalSpillOverSum = 0;
        let totalOccupiedSum = 0;
        let totalHoldSum = 0;

        Data.forEach((data) => {
          if (!data?.camera_locations) return;

          let ocrOccupied = {};
          if (data?.ocr_grid_wise_occupied && data?.ocr_occupied_area > 0) {
            try {
              ocrOccupied = JSON.parse(data?.ocr_grid_wise_occupied) ?? {};
            } catch {
              ocrOccupied = {};
            }
          }

          let gridAllocation = [];
          // data?.ocr_occupied_area > 0 &&
          // data?.occupied_area > 0 &&
          if (
            (data?.carting_data?.length > 0 || data?.destuffing_data?.length > 0)
          ) {
            try {
              const parsed = JSON.parse(data?.grid_allocation) ?? {};
              for (const value of Object.values(parsed)) {
                let values = [];
                try {
                  values = Array.isArray(value) ? value : JSON.parse(value);
                } catch {
                  continue;
                }
                if (Array.isArray(values)) {
                  gridAllocation.push(...values);
                }
              }
            } catch {}
          }

          const occupiedData = ocrOccupied?.data ?? {};
          for (const [key, value] of Object.entries(occupiedData)) {
            const index = Number(key);
            if (value === "F" && !gridAllocation.includes(index + 1)) {
              totalSpillOverSum += 1;
            }
          }

          totalOccupiedSum += gridAllocation.length;
          totalHoldSum += Number(data?.hold_cargo_area ?? 0);
          totalAreaSum += Number(data?.total_area ?? 20);
        });

        setTotal({
          totalAreaSum,
          totalSpillOverSum,
          totalOccupiedSum,
          totalHoldSum,
          totalAvailable:
            totalAreaSum - totalSpillOverSum - totalOccupiedSum - totalHoldSum,
        });
      } catch (error) {
        Swal.fire({
          icon: "error",
          text: `Error fetching data: ${error.message}`,
          timer: 3000,
          showConfirmButton: false,
        });
      } finally {
        setLoading(false);
      }
    };

    if (warehouse_name && warehouse_type) {
      fetchData();
    }
  }, [warehouse_name, warehouse_type]);

  return { loading, total };
};
